module.exports = __webpack_public_path__ + "img/twitter.a54e15e3.png";